module.exports = __webpack_public_path__ + "img/share.4a7d0b1a.svg";